// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"eebfd5d5","173":"eebfd5d5"}[chunkId] + ".chunk.css";
};